import type { OrgRelationshipKind } from '@/gql/graphql';

/** All user-facing strings for the relationship console + context switcher. */
export const RELATIONSHIP_COPY = {
  kindLabel: {
    MANAGES: 'Manages',
    PROVIDES_SERVICE: 'Provides service',
    EOR_PLACEMENT: 'EOR placement',
    AOR_PLACEMENT: 'AOR placement',
  } satisfies Record<OrgRelationshipKind, string>,
  managedByPrefix: 'Managed by',
  actAs: 'Act as',
  sectionRelationships: 'Cross-org relationships',
  sectionManagedBy: 'Managed by',
  emptyRelationships: 'No cross-org relationships yet.',
  emptyAgencies: 'No managing agencies.',
  loadError: 'Could not load relationships. Retry.',
  noMembership: "You don't have access to that context.",
} as const;

export function kindLabel(kind: OrgRelationshipKind): string {
  return RELATIONSHIP_COPY.kindLabel[kind];
}
